export default function Logo({ markClass = "h-8 w-8", wordClass = "text-lg" }) {
    return (
        <span className="flex items-center gap-2.5">
            <svg viewBox="0 0 64 64" className={markClass} aria-hidden="true">
                <defs>
                    <linearGradient id="nexg-logo" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#00F0FF" />
                        <stop offset="1" stopColor="#7000FF" />
                    </linearGradient>
                </defs>
                <rect width="64" height="64" rx="14" fill="#0B0E1A" />
                <rect
                    x="1.5"
                    y="1.5"
                    width="61"
                    height="61"
                    rx="13"
                    fill="none"
                    stroke="url(#nexg-logo)"
                    strokeOpacity="0.55"
                    strokeWidth="2"
                />
                <path
                    d="M22 46V18l20 28V18"
                    fill="none"
                    stroke="url(#nexg-logo)"
                    strokeWidth="5.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            <span
                className={`font-display font-bold tracking-[0.18em] text-white ${wordClass}`}
            >
                NEXORA
            </span>
        </span>
    );
}
